var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"text"},[_vm._v(" 当前："+_vm._s(_vm.title)+" ")]),_c('div',[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.back}},[_vm._v(" 显示上一步 ")]),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.next}},[_vm._v(" "+_vm._s(_vm.desc)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }